import React, {useState} from "react";
import {Col, Form, InputNumber, Modal, Row} from "antd";
import {useTranslate} from "../../../../../../../../hooks/translate.hook";
import {Price} from "../../../../../../../../models/articles/articles.prices";
import {ArticleData} from "../../../../../../../../models/articles/article.data";
import {articlesPrisesService} from "../../../../../../../../services/articles/articles/articles.prices.service";
import {notifications} from "../../../../../../../../services/notifications/notifications";

interface ChangePriceModalProps {
    article: ArticleData;
    price: Price;
    onClose: () => void;
}

export const ChangePriceModal: React.FC<ChangePriceModalProps> = ({article, price, onClose}) => {

    const t = useTranslate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <Modal
            width={"350px"}
            visible={true}
            title={article.name + " - " + price.price.name}
            loading={loading}
            onCancel={() => onClose()}
            onOk={() => form.submit()}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    price: price.amount.value,
                    minimalPrice: price.minimalAmount.value
            }}
                onFinish={() =>
                    form.validateFields().then(async (values) => {
                        try {
                            setLoading(true)
                            await articlesPrisesService.changePrice(article.id, price.price.id, values)
                            onClose()
                            notifications.successfully()
                        } catch (e: any) {
                            if (e.response?.data.fields) {
                                form.setFields(e.response?.data?.fields);
                            }
                        } finally {
                            setLoading(false)
                        }
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item name={"price"} label={t("PRICE")}>
                            <InputNumber addonBefore={price.amount.currencyCode.toUpperCase()} disabled={loading} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name={"minimalPrice"} label={t("PRICES.MINIMAL_PRICE")}>
                            <InputNumber addonBefore={price.minimalAmount.currencyCode.toUpperCase()} disabled={loading} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}